(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25661],{

/***/ 74573:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
}), 'ChatBubbleOutline');

exports.Z = _default;

/***/ }),

/***/ 80366:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 83792:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
}), 'Facebook');

exports.Z = _default;

/***/ }),

/***/ 66081:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
}), 'Link');

exports.Z = _default;

/***/ }),

/***/ 53093:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
}), 'Share');

exports.Z = _default;

/***/ }),

/***/ 44704:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
}), 'Twitter');

exports.Z = _default;

/***/ }),

/***/ 20640:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(11742);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 4313:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/profile/[id]",
      function () {
        return __webpack_require__(32999);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* reexport safe */ firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__.vY; }
/* harmony export */ });
/* harmony import */ var firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36068);


(0,firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();



/***/ }),

/***/ 95547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81268);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




/* 로그인 모달 */ var LoginModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "text-2xl text-primary font-bold font-gmarket-medium",
                            id: "modal-title",
                            children: "로그인 후 이용하실 수 있습니다."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mb-0 text-888 font-gmarket-medium",
                            children: "로그인하기 버튼을 클릭하여 아이소 로그인해주세요."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-footer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "button",
                            className: "btn btn-modal-o w-1/2 mr-2",
                            onClick: closeModal,
                            children: "확인"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: "/signin",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "btn btn-grayPrimary w-1/2",
                                children: "로그인하기"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoginModal);


/***/ }),

/***/ 9085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_FormatDate__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87936);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81268);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(80366);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33426);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34950);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79794);












var MessageSendModal = function(param) {
    var messageModalVisible = param.messageModalVisible, closeModal = param.closeModal, receiveEmail = param.receiveEmail, receiveUserName = param.receiveUserName;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), message = ref[0], setMessage = ref[1];
    var handleModalOkButton = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
            var date, createdAt, text, sendEmail, sendUserName, collectionRefReceive, values, _tmp, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        date = new Date();
                        createdAt = (0,components_FormatDate__WEBPACK_IMPORTED_MODULE_8__/* .FormatDate */ .r2)(date);
                        if (message === "") {
                            text = "전송할 메시지 내용을 작성해주세요.";
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text);
                            return [
                                2
                            ];
                        }
                        sendEmail = settings.email;
                        sendUserName = settings.name;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc(receiveEmail).collection("message")
                        ];
                    case 2:
                        collectionRefReceive = _state.sent();
                        _tmp = {};
                        values = (_tmp.sendEmail = sendEmail, _tmp.sendUserName = sendUserName, _tmp.message = message, _tmp.receiveEmail = receiveEmail, _tmp.receiveUserName = receiveUserName, _tmp.createdAt = createdAt, _tmp);
                        return [
                            4,
                            collectionRefReceive.add(values).then(function() {
                                var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(doc) {
                                    var docRefSend;
                                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc(sendEmail).collection("message").doc(doc.id)
                                                ];
                                            case 1:
                                                docRefSend = _state.sent();
                                                return [
                                                    4,
                                                    docRefSend.set(values)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(doc) {
                                    return _ref.apply(this, arguments);
                                };
                            }())
                        ];
                    case 3:
                        _state.sent();
                        setMessage("");
                        closeModal();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("메시지가 전송되었습니다.");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        setMessage("");
                        closeModal();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("메시지 전송 실패");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleModalOkButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        open: messageModalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content center modal-width-150",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: function() {
                                return closeModal();
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    className: "text-primary font-gmarket-medium text-2xl font-bold mb-4 center",
                    children: "메시지 전송"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full flex justify-start px-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "pr-2",
                            children: "받는 사람"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "pr-2",
                            children: ":"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: receiveUserName ? receiveUserName.length > 15 ? "".concat(receiveUserName.slice(0, 15), "...") : receiveUserName : ""
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            placeholder: "메시지 내용을 입력하세요",
                            fullWidth: true,
                            value: message,
                            onChange: function(e) {
                                return setMessage(e.target.value);
                            },
                            multiline: true,
                            rows: 8,
                            className: "w-full",
                            InputLabelProps: {
                                shrink: true
                            }
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "btn btn-modal-o w-2/3 py-3",
                        onClick: function() {
                            return handleModalOkButton();
                        },
                        children: "보내기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MessageSendModal);


/***/ }),

/***/ 49957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81268);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33426);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80366);






/* 신고하기 모달 */ var ReportModal = function(param) {
    var modalVisible = param.modalVisible, closeModal = param.closeModal, handleModalOkButton = param.handleModalOkButton, title = param.title, setTitle = param.setTitle, content = param.content, setContent = param.setContent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content m-0 modal-width-180",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            "aria-label": "close",
                            className: "w-15 h-15",
                            onClick: closeModal,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                    className: "text-danger font-gmarket-medium text-2xl font-bold mb-4 center",
                    children: "신고하기"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                label: "제목",
                                placeholder: "신고할 내용의 제목을 입력하세요",
                                fullWidth: true,
                                value: title,
                                onChange: function(e) {
                                    return setTitle(e.target.value);
                                },
                                margin: "normal",
                                InputLabelProps: {
                                    shrink: true
                                },
                                className: "mt-4 w-full"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full py-3",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                label: "내용",
                                placeholder: "신고 내용을 입력하세요",
                                fullWidth: true,
                                value: content,
                                onChange: function(e) {
                                    return setContent(e.target.value);
                                },
                                multiline: true,
                                rows: 8,
                                className: "mt-4 w-full",
                                InputLabelProps: {
                                    shrink: true
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-footer center",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: "btn btn-modal-x w-2/5",
                        onClick: function() {
                            return handleModalOkButton();
                        },
                        children: "보내기"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReportModal);


/***/ }),

/***/ 32999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./stores/settings.js
var stores_settings = __webpack_require__(31806);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Function.js
var Function = __webpack_require__(63689);
// EXTERNAL MODULE: ./components/UserPhoto.js
var UserPhoto = __webpack_require__(64410);
// EXTERNAL MODULE: ./components/UserName.js
var UserName = __webpack_require__(37915);
// EXTERNAL MODULE: ./components/ProjectFirestore.js
var ProjectFirestore = __webpack_require__(79794);
// EXTERNAL MODULE: ./components/Paginations.js
var Paginations = __webpack_require__(71094);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Share.js
var Share = __webpack_require__(53093);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ReportOutlined.js
var ReportOutlined = __webpack_require__(77217);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ChatBubbleOutline.js
var ChatBubbleOutline = __webpack_require__(74573);
// EXTERNAL MODULE: ./components/ProjectStorage.js
var ProjectStorage = __webpack_require__(8522);
// EXTERNAL MODULE: ./components/modal/MessageSendModal.js
var MessageSendModal = __webpack_require__(9085);
// EXTERNAL MODULE: ./components/modal/ShareModal.js
var ShareModal = __webpack_require__(76195);
// EXTERNAL MODULE: ./components/FormatDate.js
var FormatDate = __webpack_require__(87936);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./components/modal/LoginModal.js
var LoginModal = __webpack_require__(95547);
// EXTERNAL MODULE: ./components/modal/ReportModal.js
var ReportModal = __webpack_require__(49957);
// EXTERNAL MODULE: ./components/appCard/Card.js
var Card = __webpack_require__(78739);
;// CONCATENATED MODULE: ./components/UserEmail.js




var UserEmail = function(uid) {
    var ref = (0,react.useState)(""), email = ref[0], setEmail = ref[1];
    (0,react.useEffect)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var colRef, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!uid) return [
                        3,
                        6
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        ProjectFirestore/* projectFirestore.collection */.H.collection("users").where("id", "==", uid).get()
                    ];
                case 2:
                    colRef = _state.sent();
                    if (!(colRef.docs.length > 0)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        colRef.forEach(function(doc) {
                            setEmail(doc.data().email);
                        })
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        6
                    ];
                case 5:
                    error = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    }), [
        uid
    ]);
    return email;
};
/* harmony default export */ var components_UserEmail = (UserEmail);

;// CONCATENATED MODULE: ./pages/user/profile/[id].js
/** @format */ 











// import AppLikeCounㄴt from "components/AppLikeCount";





// Marerial Icon











var Profile = function() {
    var router = (0,next_router.useRouter)();
    /* 페이지네이션 */ var ref = (0,react.useState)([]), pageOfItems = ref[0], setPageOfItems = ref[1];
    // const [page, setPage] = useState(settings.aisoMarketPage);
    var ref1 = (0,react.useState)(null), contentsData = ref1[0], setContentsData = ref1[1];
    var ref2 = (0,react.useState)(0), imageItemsCount = ref2[0], setImageItemsCount = ref2[1];
    var ref3 = (0,react.useState)(0), dataItemsCount = ref3[0], setDataItemsCount = ref3[1];
    var ref4 = (0,react.useState)("market"), tab = ref4[0], setTab = ref4[1];
    var id = router.query.id;
    var email = components_UserEmail(id);
    /* 카테고리별 데이터 저장 */ (0,react.useEffect)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var datas, collectionRef, collectionValue, tempDatas, tempImageItemLength, tempDataItemLength, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!email) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    datas = [];
                    collectionRef = ProjectFirestore/* projectFirestore.collection */.H.collection("market").doc("public").collection("app");
                    return [
                        4,
                        collectionRef.where("email", "==", email).get()
                    ];
                case 2:
                    collectionValue = _state.sent();
                    collectionValue.forEach(function(doc) {
                        /* 완성되지 않은 앱은 목록에서 제거 */ if (doc.data().status === "앱 배포완료" && doc.data().visible) {
                            datas.push((0,_object_spread/* default */.Z)({}, doc.data()));
                        }
                    });
                    tempDatas = datas.sort(Function/* DateDescendingOrder */.Zb);
                    if (tab === "dataAnalysis") {
                        tempDatas = tempDatas.filter(function(f) {
                            return f.category === "dataAnalysis";
                        });
                    } else {
                        tempDatas = tempDatas.filter(function(f) {
                            return f.category !== "dataAnalysis";
                        });
                    }
                    setContentsData(tempDatas);
                    tempImageItemLength = datas.filter(function(f) {
                        return f.category !== "dataAnalysis";
                    }).length;
                    tempDataItemLength = datas.filter(function(f) {
                        return f.category === "dataAnalysis";
                    }).length;
                    setImageItemsCount(tempImageItemLength);
                    setDataItemsCount(tempDataItemLength);
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        router,
        tab,
        email
    ]);
    /* 페이지네이션 */ var onChangePage = function(pageOfItems) {
        setPageOfItems(pageOfItems);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "page-content w-full pt-10 pb-20",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDotMenu, {
                    email: email,
                    imageItemsCount: imageItemsCount,
                    dataItemsCount: dataItemsCount
                }),
                contentsData ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12 mt-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "flex items-center m-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "nav-item mr-3",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "nav-link category-simple-menu ".concat(tab === "market" ? "active" : ""),
                                            onClick: function() {
                                                return setTab("market");
                                            },
                                            children: "마켓 앱"
                                        })
                                    })
                                })
                            }),
                            contentsData.length > 0 ? tab === "market" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "app-content-wrap",
                                        children: pageOfItems.map(function(m) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAppCard, {
                                                data: m
                                            }, m.appId);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paginations/* default */.Z, {
                                        items: contentsData,
                                        onChangePage: onChangePage
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-12 py-3 sm:py-0",
                                        children: pageOfItems.map(function(m) {
                                            return /*#__PURE__*/ (0,react.createElement)(DataAnalysisMarketCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, m), {
                                                key: m.appId
                                            }));
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paginations/* default */.Z, {
                                        items: contentsData,
                                        onChangePage: onChangePage
                                    })
                                ]
                            }) : ""
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "center w-full py-32",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Loading..."
                    })
                })
            ]
        })
    });
};
/* 제작자 정보 */ var ProfileDotMenu = function(param) {
    var email = param.email, imageItemsCount = param.imageItemsCount, dataItemsCount = param.dataItemsCount;
    var settings = (0,stores_settings/* default */.Z)();
    var photoUrl = (0,UserPhoto/* default */.Z)(email);
    var appUserName = (0,UserName/* default */.Z)(email);
    ;
    // 모달 값 저장
    var ref = (0,react.useState)(false), loginModalVisible = ref[0], setLoginModalVisible = ref[1];
    var ref1 = (0,react.useState)(false), messageModalVisible = ref1[0], setMessageModalVisible = ref1[1];
    var ref2 = (0,react.useState)(false), reportModalVisible = ref2[0], setReportModalVisible = ref2[1];
    var ref3 = (0,react.useState)(""), title = ref3[0], setTitle = ref3[1];
    var ref4 = (0,react.useState)(""), content = ref4[0], setContent = ref4[1];
    var handleMessageSendButtonClick = function() {
        /* 로그인 체크하고 로그인 후 이용해달라고 하기 */ if (!settings.email) {
            setLoginModalVisible(true);
            return "";
        }
        setMessageModalVisible(true);
    };
    var handleReportSendButtonClick = function() {
        /* 로그인 체크하고 로그인 후 이용해달라고 하기 */ if (!settings.email) {
            setLoginModalVisible(true);
            return "";
        }
        setReportModalVisible(true);
    };
    var handleModalOkButton = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var date, createdAt, text, text1, collectionRefUser, values, _tmp, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        date = new Date();
                        createdAt = (0,FormatDate/* FormatDate */.r2)(date);
                        if (title === "") {
                            text = "신고 제목을 입력해주세요.";
                            BasicAlert(text);
                            return [
                                2
                            ];
                        }
                        if (content === "") {
                            text1 = "신고 내용을 입력해주세요.";
                            BasicAlert(text1);
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            ProjectFirestore/* projectFirestore.collection */.H.collection("admin").doc("report").collection("users")
                        ];
                    case 2:
                        collectionRefUser = _state.sent();
                        _tmp = {};
                        values = (_tmp.email = email, _tmp.name = appUserName, _tmp.reporterEmail = settings.email, _tmp.reporterName = settings.name, _tmp.title = title, _tmp.content = content, _tmp.createdAt = createdAt, _tmp.status = "미확인", _tmp);
                        return [
                            4,
                            collectionRefUser.add(values)
                        ];
                    case 3:
                        _state.sent();
                        setTitle("");
                        setContent("");
                        setReportModalVisible(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        BasicAlert("신고 등록 실패");
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleModalOkButton() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full aiso-card shadow-sm py-5",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "row items-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-12 col-sm-3 center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "img-cover-box w-24 h-24 rounded-full border",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: photoUrl,
                            className: "rounded-full",
                            alt: "user photo"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col-12 col-sm-9",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-center items-center justify-content-sm-between align-items-sm-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col flex-sm-row items-center justify-between w-full",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "truncate-1-lines text-2xl text-555 mt-3 mb-0 mr-sm-3 font-bold",
                                        children: appUserName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-between pt-2 sm:pt-0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                    title: "메시지 보내기",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        color: "primary",
                                                        onClick: handleMessageSendButtonClick,
                                                        className: "p-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatBubbleOutline/* default */.Z, {
                                                            className: "text-333"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mr-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                                    title: "신고하기",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                        color: "primary",
                                                        onClick: handleReportSendButtonClick,
                                                        className: "p-2",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportOutlined/* default */.Z, {
                                                            className: "text-333"
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageSendModal/* default */.Z, {
                                                messageModalVisible: messageModalVisible,
                                                closeModal: function() {
                                                    return setMessageModalVisible(false);
                                                },
                                                receiveEmail: email,
                                                receiveUserName: appUserName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportModal/* default */.Z, {
                                                modalVisible: reportModalVisible,
                                                closeModal: function() {
                                                    return setReportModalVisible(false);
                                                },
                                                handleModalOkButton: handleModalOkButton,
                                                title: title,
                                                setTitle: setTitle,
                                                content: content,
                                                setContent: setContent
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal/* default */.Z, {
                                                modalVisible: loginModalVisible,
                                                closeModal: function() {
                                                    return setLoginModalVisible(false);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full flex flex-col flex-sm-row justify-center justify-content-sm-start items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "text-sm mr-sm-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-555 pr-2",
                                            children: "마켓 앱"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-333 font-black",
                                            children: imageItemsCount
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var UserAppCard = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        data: data,
        pathname: "/user/market/[id]",
        query: {
            id: data.appId
        }
    });
};
/* 데이터 분석 카드 */ var DataAnalysisMarketCard = function(param) {
    var appId = param.appId, email = param.email, appName = param.appName, price = param.price, createdAt = param.createdAt, oneLineContent = param.oneLineContent, useCount = param.useCount, imageUrl = param.imageUrl;
    /* preview 가져오기 */ /* 사용자 프로필 가져오기 */ var photoUrl = (0,UserPhoto/* default */.Z)(email);
    var name = (0,UserName/* default */.Z)(email);
    /* 좋아요 수 체크 */ // const likeCount = AppLikeCount(email, appId);
    var ref = (0,react.useState)(), appImage = ref[0], setAppImage = ref[1];
    (0,react.useEffect)(function() {
        if (imageUrl) {
            var storageFileRef = ProjectStorage/* projectStorage.ref */.v.ref(imageUrl);
            storageFileRef.getDownloadURL().then(function(url) {
                try {
                    setAppImage(url);
                } catch (e) {
                    ;
                }
            });
        }
    }, [
        imageUrl
    ]);
    /* Modal */ var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col sm:flex-row items-center aiso-data-card aiso-shadow mb-3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: {
                        pathname: "/user/dataAnalysis/[id]",
                        query: {
                            id: "".concat(appId)
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full sm:w-2/12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "img-cover-box h-48",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: appImage ? appImage : "/images/market/no-img.png",
                                className: "rounded-tl-md rounded-bl-md"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-full sm:w-10/12 py-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex justify-between items-center px-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: {
                                        pathname: "/user/dataAnalysis/[id]",
                                        query: {
                                            id: "".concat(appId)
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "px-3",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "truncate-2-lines text-333 font-bold font-gmarket-medium",
                                                children: appName
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "truncate-1-lines font-gmarket-medium text-888 mt-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: oneLineContent
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    className: "text-ss text-333 font-gmarket-medium mr-5",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "font-bold text-sm",
                                                            children: useCount ? useCount : "0"
                                                        }),
                                                        " 회 사용"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                                            title: "공유하기",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                color: "primary",
                                                onClick: handleOpen,
                                                className: "p-2",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Share/* default */.Z, {
                                                    className: "text-333"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ShareModal/* default */.Z, {
                                            open: open,
                                            handleClose: handleClose,
                                            path: "/user/dataAnalysis/".concat(appId),
                                            title: appName,
                                            description: oneLineContent
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex justify-between items-end px-3 mt-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-start items-center px-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "img-cover-box w-10 h-10 rounded-full border",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: photoUrl,
                                                    alt: "profile"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "whitespace-pre-line break-all ml-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "truncate-1-lines mb-0 text-555 font-gmarket-medium text-sm",
                                                    children: name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "mb-0 text-aaa font-gmarket-medium text-xs",
                                                    children: createdAt.substring(0, 16)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "px-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-xs text-333 font-gmarket-medium",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "font-bold text-base text-primary",
                                                children: price
                                            }),
                                            " Credit"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var _id_ = (Profile);


/***/ }),

/***/ 52205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Pagination; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/SafeAnchor.js
var SafeAnchor = __webpack_require__(48358);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/PageItem.js



/* eslint-disable react/no-multi-comp */



var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
var PageItem = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);

  var Component = active || disabled ? 'span' : SafeAnchor/* default */.Z;
  return /*#__PURE__*/react.createElement("li", {
    ref: ref,
    style: style,
    className: classnames_default()(className, 'page-item', {
      active: active,
      disabled: disabled
    })
  }, /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    className: "page-link",
    disabled: disabled
  }, props), children, active && activeLabel && /*#__PURE__*/react.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
});
PageItem.defaultProps = defaultProps;
PageItem.displayName = 'PageItem';
/* harmony default export */ var esm_PageItem = (PageItem);

function createButton(name, defaultValue, label) {
  if (label === void 0) {
    label = name;
  }

  function Button(_ref2) {
    var children = _ref2.children,
        props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["children"]);

    return /*#__PURE__*/react.createElement(PageItem, props, /*#__PURE__*/react.createElement("span", {
      "aria-hidden": "true"
    }, children || defaultValue), /*#__PURE__*/react.createElement("span", {
      className: "sr-only"
    }, label));
  }

  Button.displayName = name;
  return Button;
}

var First = createButton('First', '«');
var Prev = createButton('Prev', '‹', 'Previous');
var Ellipsis = createButton('Ellipsis', '…', 'More');
var Next = createButton('Next', '›');
var Last = createButton('Last', '»');
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Pagination.js







/**
 * @property {PageItem} Item
 * @property {PageItem} First
 * @property {PageItem} Prev
 * @property {PageItem} Ellipsis
 * @property {PageItem} Next
 * @property {PageItem} Last
 */
var Pagination = /*#__PURE__*/react.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      children = _ref.children,
      size = _ref.size,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["bsPrefix", "className", "children", "size"]);

  var decoratedBsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'pagination');
  return /*#__PURE__*/react.createElement("ul", (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    className: classnames_default()(className, decoratedBsPrefix, size && decoratedBsPrefix + "-" + size)
  }), children);
});
Pagination.First = First;
Pagination.Prev = Prev;
Pagination.Ellipsis = Ellipsis;
Pagination.Item = esm_PageItem;
Pagination.Next = Next;
Pagination.Last = Last;
/* harmony default export */ var esm_Pagination = (Pagination);

/***/ }),

/***/ 74300:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CopyToClipboard = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _copyToClipboard = _interopRequireDefault(__webpack_require__(20640));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CopyToClipboard =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CopyToClipboard, _React$PureComponent);

  function CopyToClipboard() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CopyToClipboard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CopyToClipboard)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props = _this.props,
          text = _this$props.text,
          onCopy = _this$props.onCopy,
          children = _this$props.children,
          options = _this$props.options;

      var elem = _react["default"].Children.only(children);

      var result = (0, _copyToClipboard["default"])(text, options);

      if (onCopy) {
        onCopy(text, result);
      } // Bypass onClick if it was present


      if (elem && elem.props && typeof elem.props.onClick === 'function') {
        elem.props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(CopyToClipboard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _text = _this$props2.text,
          _onCopy = _this$props2.onCopy,
          _options = _this$props2.options,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, ["text", "onCopy", "options", "children"]);

      var elem = _react["default"].Children.only(children);

      return _react["default"].cloneElement(elem, _objectSpread({}, props, {
        onClick: this.onClick
      }));
    }
  }]);

  return CopyToClipboard;
}(_react["default"].PureComponent);

exports.CopyToClipboard = CopyToClipboard;

_defineProperty(CopyToClipboard, "defaultProps", {
  onCopy: undefined,
  options: undefined
});

/***/ }),

/***/ 74855:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(74300),
    CopyToClipboard = _require.CopyToClipboard;

CopyToClipboard.CopyToClipboard = CopyToClipboard;
module.exports = CopyToClipboard;

/***/ }),

/***/ 11742:
/***/ (function(module) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [34619,52387,94924,33426,76328,85388,868,22004,39054,57333,19388,28188,49774,92888,40179], function() { return __webpack_exec__(4313); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);